var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReturnIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.733 19.79C10.878 19.9213 11.0686 19.9907 11.2641 19.9834C11.4596 19.9761 11.6445 19.8927 11.7794 19.7511C11.9143 19.6094 11.9885 19.4206 11.9862 19.225C11.9838 19.0294 11.9052 18.8425 11.767 18.704L5.51599 12.75H20.25C20.4489 12.75 20.6397 12.671 20.7803 12.5303C20.921 12.3897 21 12.1989 21 12C21 11.8011 20.921 11.6103 20.7803 11.4697C20.6397 11.329 20.4489 11.25 20.25 11.25H5.51599L11.767 5.29502C11.9052 5.15658 11.9838 4.96962 11.9862 4.77402C11.9885 4.57841 11.9143 4.38964 11.7794 4.24797C11.6445 4.1063 11.4596 4.02293 11.2641 4.01566C11.0686 4.00838 10.878 4.07777 10.733 4.20902L3.31299 11.276C3.15059 11.4301 3.0449 11.6344 3.01299 11.856C2.99469 11.9515 2.99503 12.0496 3.01399 12.145C3.04611 12.3662 3.15179 12.5702 3.31399 12.724L10.733 19.791V19.79Z",
    fill: "#128087"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnIcon);
export default __webpack_public_path__ + "static/media/ReturnIcon.fd4675d1c14b4ff2ac6cf39cd7d5c0ab.svg";
export { ForwardRef as ReactComponent };